import { onBeforeUnmount, onMounted } from 'vue'

export function prefersDark(): boolean {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

export function syncDocumentColorScheme() {
  document.documentElement.classList.toggle('dark', prefersDark())
}

export function onColorSchemeChange(cb: () => void): () => void {
  const mq = window.matchMedia('(prefers-color-scheme: dark)')
  const handler = () => {
    syncDocumentColorScheme()
    cb()
  }
  mq.addEventListener('change', handler)
  return () => mq.removeEventListener('change', handler)
}

/** Call from `setup()` so charts and canvases rebuild when the OS theme changes. */
export function watchColorScheme(rebuild: () => void) {
  let stop: (() => void) | undefined
  onMounted(() => {
    stop = onColorSchemeChange(rebuild)
  })
  onBeforeUnmount(() => {
    stop?.()
  })
}
